module.exports = __webpack_public_path__ + "img/FooterSariAsih.34fb1d53.png";